import axios from 'axios';
import { Setting, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';
import dayjs from "dayjs";

export const useUpdateDeliveryDate = (setting: Setting) => {
  const updateDeliveryDate = (subscriptionContractId: string, nextBillingDate: Date, deliveryDate: Date, success:() => void, failed?: (message: string) => void) => {
    (async () => {
      try {
        await axios.post(
          `${CUSTOMER_API_URL}?action=updateDeliveryDays`,
          {
            subscriptionId: subscriptionContractId,
            deliveryDays: dayjs(deliveryDate).diff(dayjs(nextBillingDate), 'day'),
          },
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    updateDeliveryDate,
  };
};
